/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { useSimpliCity } from "cms/hooks/use-simplicity";
import { exists, isNull, isObject, objectHasPropertyString } from "cms/utils/empty-exists";
import { Logger } from "cms/utils/logger";
// import { ServicesHeader } from 'components/services-header'
// import { ServicesFooter } from 'components/services-footer'
import { Footer } from "components/footer";
import { Header } from "components/header";

const ErrorLayout = () => {

    const {
        error,
        // errorWebpage,
        // errorModel,
        // errorFields,
        // setModel,
    } = useSimpliCity();
    // const { title } = errorModel || {}
    // const { body } = errorFields || {}
    const wasNull = isNull(error);
    const didExist = exists(error);
    const wasErrorObject = isObject(error) && objectHasPropertyString(error, "message");
    const hasError = !wasNull && didExist && wasErrorObject;
    let displayedError = "";
    if (hasError) {
        Logger.warn("[ErrorLayout] Error Occurred: " + error?.message);
        Logger.warn("[ErrorLayout] Error trace: " + error?.trace);
        Logger.warn("[ErrorLayout] Error stack: " + error?.stack);
        Logger.error(error);
        displayedError = hasError ? JSON.stringify(error, null, 2) : "";
        // need to set model for Richtext component internals
        // setModel(errorModel)
    } else {
        return null;
    }
    const title = "Sorry, that page is no longer available";

    return (
        <div className='layout-with-footer'>
            <Header />

            <div id="layout-fullwidth" className="layout-fullwidth layout-margins">

                <div className="main-content">

                    {/* Title */}
                    <h1 className="page-title">{title}</h1>

                    <div>
                        {hasError &&
                            <details>
                                <summary>
                                    <div style={{
                                        display: "flex", justifyContent: "flex-start", padding: "20px, 20px, 20px, 20px"
                                    }}
                                    >
                                        Error Details
                                    </div>
                                </summary>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <div style={{
                                        border: "1px solid black",
                                        borderRadius: "8px",
                                        overflow: "auto",
                                        width: "100%",
                                        maxWidth: "1200px",
                                        // height: '600px',
                                        padding: "40px"
                                    }}
                                    >
                                        <pre style={{ width: "1000px" }}>
                                            {displayedError}
                                        </pre>
                                    </div>
                                </div>
                            </details>
                        }
                    </div>

                </div>

            </div>

            <Footer />
        </div>
    );
};
ErrorLayout.displayName = "ErrorLayout";
export { ErrorLayout };

